var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"sidebar"}},[(_vm.$store.state.ta_list)?_c('TransactionList',{staticStyle:{"height":"100%","overflow-y":"auto"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }